export const imageData = [
    {
      "date": "2025-12-03",
      "title":"Készülődés a karácsonyra",
      "mainimage":"../images/nappali/2025.12.03/2.jpg",
      "images": 
        {
          "image1": "../images/nappali/2025.12.03/1.jpg",
          "image2": "../images/nappali/2025.12.03/2.jpg",
          "image3": "../images/nappali/2025.12.03/3.jpg",
          "image4": "../images/nappali/2025.12.03/4.jpg",
          "image5": "../images/nappali/2025.12.03/5.jpg",
          "image6": "../images/nappali/2025.12.03/6.jpg",
          "image7": "../images/nappali/2025.12.03/7.jpg",
          "image8": "../images/nappali/2025.12.03/8.jpg",
          "image9": "../images/nappali/2025.12.03/9.jpg",
        }
      
    },
    {
      "date": "2026-01-15",
      "title":"Egy kis játék",
        "mainimage":"../images/nappali/2026.01.15/5.jpg",
      "images": 
        {
          "image1": "../images/nappali/2026.01.15/1.jpg",
          "image2": "../images/nappali/2026.01.15/2.jpg",
          "image3": "../images/nappali/2026.01.15/3.jpg",
          "image4": "../images/nappali/2026.01.15/4.jpg",
          "image5": "../images/nappali/2026.01.15/5.jpg",
          "image6": "../images/nappali/2026.01.15/6.jpg",
          "image7": "../images/nappali/2026.01.15/7.jpg",
          "image8": "../images/nappali/2026.01.15/8.jpg",
          "image9": "../images/nappali/2026.01.15/9.jpg",
          "image10": "../images/nappali/2026.01.15/10.jpg",
          "image11": "../images/nappali/2026.01.15/11.jpg",
          "image12": "../images/nappali/2026.01.15/12.jpg",
          "image13": "../images/nappali/2026.01.15/13.jpg",
          "image14": "../images/nappali/2026.01.15/14.jpg",
          "image15": "../images/nappali/2026.01.15/15.jpg",
          "image16": "../images/nappali/2026.01.15/16.jpg",
          "image17": "../images/nappali/2026.01.15/17.jpg",
          "image18": "../images/nappali/2026.01.15/18.jpg",
          "image19": "../images/nappali/2026.01.15/19.jpg",
          "image20": "../images/nappali/2026.01.15/20.jpg",
          "image21": "../images/nappali/2026.01.15/21.jpg",
          
        }
    },
     {
        "date": "2025-06-08",
        "title":"Kirándulás",
       "mainimage":"../images/nappali/2025.07.12/1.jfif",
        "images": 
          {
          "image1": "../images/nappali/2025.07.12/1.jfif",
          "image2": "../images/nappali/2025.07.12/2.jfif",
          "image3": "../images/nappali/2025.07.12/3.jfif",
          "image4": "../images/nappali/2025.07.12/4.jfif",
          "image5": "../images/nappali/2025.07.12/5.jfif",
          "image6": "../images/nappali/2025.07.12/6.jfif",
          "image7": "../images/nappali/2025.07.12/7.jfif",
          "image8": "../images/nappali/2025.07.12/8.jfif",
          "image9": "../images/nappali/2025.07.12/9.jfif",
          "image10": "../images/nappali/2025.07.12/10.jfif",
          "image11": "../images/nappali/2025.07.12/11.jfif",
          "image12": "../images/nappali/2025.07.12/12.jfif",
          }
        
    }, {
        "date": "2026-04-09",
        "title":"Tojáskeresés",
       "mainimage":"../images/nappali/2026.04.09/1.jpg",
        "images": 
          {
          "image1": "../images/nappali/2026.04.09/1.jpg",
          "image2": "../images/nappali/2026.04.09/2.jpg",
          "image3": "../images/nappali/2026.04.09/3.jpg",
          "image4": "../images/nappali/2026.04.09/4.jpg",
          "image5": "../images/nappali/2026.04.09/5.jpg",
          "image6": "../images/nappali/2026.04.09/6.jpg",
          "image7": "../images/nappali/2026.04.09/7.jpg",
          "image8": "../images/nappali/2026.04.09/8.jpg",
          "image9": "../images/nappali/2026.04.09/9.jpg",
          "image10": "../images/nappali/2026.04.09/10.jpg",
          "image11": "../images/nappali/2026.04.09/11.jpg",
          "image12": "../images/nappali/2026.04.09/12.jpg",
          "image13": "../images/nappali/2026.04.09/13.jpg",
          }
        
    }, {
        "date": "2026-04-04",
        "title":"Játék,móka, kacagás",
       "mainimage":"../images/nappali/2026.04.04/1.jpg",
        "images": 
          {
          "image1": "../images/nappali/2026.04.04/1.jpg",
          "image2": "../images/nappali/2026.04.04/2.jpg",
          "image3": "../images/nappali/2026.04.04/3.jpg",
          "image4": "../images/nappali/2026.04.04/4.jpg",
          "image5": "../images/nappali/2026.04.04/5.jpg",
          "image6": "../images/nappali/2026.04.04/6.jpg",
          "image7": "../images/nappali/2026.04.04/7.jpg",
          "image8": "../images/nappali/2026.04.04/8.jpg",
          "image9": "../images/nappali/2026.04.04/9.jpg",
          "image10": "../images/nappali/2026.04.04/10.jpg",
          }
        
    },
      
 
  ];